import { jsx } from "react/jsx-runtime";
import { AnchorButton } from "@contember/ui";
import { Link } from "./Link.js";
import { Component } from "@contember/binding";
const LinkButton = Component(({ to, ...buttonProps }) => {
  return /* @__PURE__ */ jsx(
    Link,
    {
      ...buttonProps,
      to,
      Component: AnchorButton
    }
  );
});
LinkButton.displayName = "LinkButton";
const PageLinkButton = LinkButton;
export {
  LinkButton,
  PageLinkButton
};
//# sourceMappingURL=LinkButton.js.map
